import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { SurveysSettingsDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import AddSurveyQuestionnaireTemplateModal from 'modules/surveys/components/QuestionTemplates/AddSurveyQuestionnaireTemplateModal'
import SettingsCollectionsBootstrap from 'modules/surveys/lib/SettingsCollectionsBootstrap'
import Table from 'modules/surveys/pages/QuestionsTemplates/QuestionsTemplates/Table'
import questionsTemplates from 'modules/surveys/store/collections/questionsTemplates'

const SurveySettings = () => {
  const [isModalOpen, toggleModal] = React.useState<boolean>(false)
  useAsyncData(() => questionsTemplates.fetch(), [])

  const questionsTemplatesList = questionsTemplates.models.filter(
    (questionsTemplate) => questionsTemplate.isSurvey
  )
  const { data, loading } = useQuery(SurveysSettingsDocument, {})

  const canCreateSurveyTemplates = data?.surveys._policies.createSurveyTemplates.can ?? false

  if (loading) {
    return <Loading />
  }

  if (!canCreateSurveyTemplates) {
    return <NotFound />
  }

  return (
    <SettingsCollectionsBootstrap>
      <ResponsivePage.Body>
        <Box alignItems="flexEnd" gap="s24">
          <Button onClick={() => toggleModal(true)} iconName="add">
            {i18n.t('app_store_v2.apps.performance_v2.settings.templates.add')}
          </Button>
          <Table questionsTemplatesList={questionsTemplatesList} />
        </Box>
        {isModalOpen && <AddSurveyQuestionnaireTemplateModal toggleModal={toggleModal} />}
      </ResponsivePage.Body>
    </SettingsCollectionsBootstrap>
  )
}

export default observer(SurveySettings)
